import { render, staticRenderFns } from "./graficaComponent.vue?vue&type=template&id=64d8b902&scoped=true"
import script from "./graficaComponent.vue?vue&type=script&lang=js"
export * from "./graficaComponent.vue?vue&type=script&lang=js"
import style0 from "./graficaComponent.vue?vue&type=style&index=0&id=64d8b902&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d8b902",
  null
  
)

export default component.exports